import VideoTile from './VideoTile.jsx'
import VideoControls from './VideoControls.jsx'
import ConnectionStatus from './ConnectionStatus.jsx'

export default function VideoPanel({
  localStream,
  remoteStream,
  callConnected,
  mediaError,
  isMuted,
  isCameraOff,
  connectionStatus,
  toggleMute,
  toggleCamera,
  isCreator,
  guestJoined,
}) {
  return (
    <div className="card flex flex-col gap-0 overflow-hidden">
      {/* Header */}
      <div className="px-4 py-3 border-b border-obsidian-600 flex items-center justify-between">
        <h2 className="text-ivory-300/60 text-xs font-mono uppercase tracking-widest">Video Chat</h2>
        <ConnectionStatus status={connectionStatus} callConnected={callConnected} />
      </div>

      {/* Video tiles */}
      {/* Video tiles container */}
<div className="flex flex-col xl:flex-col xl:h-[400px] bg-obsidian-900">
  
  {/* Remote video (Main/Top) */}
  <div className="relative flex-1 min-h-[240px] border-b xl:border-b-0 xl:border-r border-obsidian-600">
    <VideoTile
      stream={remoteStream}
      label={isCreator ? 'Guest' : 'Host'}
      isMain
      empty={!callConnected}
      emptyMessage={
        !guestJoined
          ? 'Waiting for opponent…'
          : connectionStatus === 'connecting'
          ? 'Connecting video…'
          : 'Video disconnected'
      }
    />
  </div>

  {/* Local video (Bottom on mobile / Right or Stacked on PC) */}
  <div className="relative h-[180px] xl:h-full bg-obsidian-950">
    <VideoTile
      stream={localStream}
      label="You"
      muted
      isLocal
      empty={!localStream || isCameraOff}
      emptyMessage="Off"
    />
  </div>
</div>

      {/* Media error */}
      {mediaError && (
        <div className="px-4 py-2 bg-crimson-500/10 border-t border-crimson-500/20 text-crimson-400 text-xs">
          ⚠ {mediaError}
        </div>
      )}

      {/* Controls */}
      <div className="px-4 py-3 border-t border-obsidian-600">
        <VideoControls
          isMuted={isMuted}
          isCameraOff={isCameraOff}
          onToggleMute={toggleMute}
          onToggleCamera={toggleCamera}
          disabled={!localStream}
        />
      </div>
    </div>
  )
}
